import { Link } from "react-router-dom";
import { services } from "../../data/services";
import { FadeIn } from "../utils/FadeIn";

/**
 * Services grid — Airon design.
 * Uses the `.services` / `.service` grid from airon-design.css.
 * Icons come from Heroicons (outline) via the services data file — the Airon
 * `.svc-icon` rounded pill styles the surround, and we render the icon at 24px.
 */
const DEFAULT_TAGS = [
  ["Aggregat", "Kanalnett", "Varmegjenvinning"],
  ["Serviceavtale", "Filter", "Rens"],
  ["Boligblokk", "Næringsbygg", "Industri"],
  ["CO₂", "VOC", "Rapport"],
  ["Borettslag", "Kontor", "Skole"],
];

export default function ServicesSection() {
  return (
    <section className="sec" id="tjenester">
      <div className="wrap">
        <div className="sec-head">
          <div className="sec-tag">01 / Tjenester</div>
          <h2>
            Alt som tilhører <em>et sunt inneklima.</em>
          </h2>
          <a
            href="/om-oss/prosjekter"
            className="sec-tag"
            style={{
              color: "var(--airon-3)",
              textDecoration: "none",
              fontFamily: "var(--mono)",
            }}
          >
            Se prosjekter →
          </a>
        </div>

        <div className="services">
          {services.map((service, idx) => {
            const Icon = service.icon;
            const tags = service.tags || DEFAULT_TAGS[idx % DEFAULT_TAGS.length];
            const card = (
              <article className="service">
                <div className="svc-icon">
                  {Icon ? (
                    <Icon style={{ width: 24, height: 24 }} aria-hidden="true" />
                  ) : null}
                </div>
                <h3 className="svc-title">
                  {service.shortTitle || service.title}
                </h3>
                <p className="svc-desc">{service.description}</p>
                {tags && tags.length ? (
                  <div className="svc-tags">
                    {tags.map((t) => (
                      <span key={t}>{t}</span>
                    ))}
                  </div>
                ) : null}
                {service.href ? (
                  <span
                    className="svc-link"
                    aria-hidden="true"
                    style={{
                      marginTop: 14,
                      display: "inline-flex",
                      alignItems: "center",
                      gap: 6,
                      fontFamily: "var(--mono)",
                      fontSize: 12,
                      letterSpacing: "0.04em",
                      textTransform: "uppercase",
                      color: "var(--airon-3)",
                    }}
                  >
                    Les mer <span className="arr">→</span>
                  </span>
                ) : null}
              </article>
            );
            return (
              <FadeIn key={service.title}>
                {service.href ? (
                  <Link
                    to={service.href}
                    className="service-link"
                    style={{
                      display: "block",
                      color: "inherit",
                      textDecoration: "none",
                      height: "100%",
                    }}
                  >
                    {card}
                  </Link>
                ) : (
                  card
                )}
              </FadeIn>
            );
          })}
        </div>
      </div>
    </section>
  );
}
